import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWifi } from '@fortawesome/free-solid-svg-icons';
import CommandHistoryBody from './CommandHistoryBody';
import CommandHistoryHeader from './CommandHistoryHeader';
import { Loading } from '../NoDataIndication';

function CommandHistoryTable(props) {
  const {
    data,
    dataLoading,
    sort,
    handleSortClick,
    status,
    handleStatusSelect,
    jobName,
    handleSearch,
    remote,
  } = props;

  return (
    <>
      <div
        className={`d-none d-md-block w-100 px-lg-4 ${
          !dataLoading && data.length ? 'h-100' : ''
        }`}
      >
        <table className="table">
          <thead>
            <CommandHistoryHeader
              sort={sort}
              handleSortClick={handleSortClick}
              status={status}
              handleStatusSelect={handleStatusSelect}
              jobName={jobName}
              handleSearch={handleSearch}
            />
          </thead>
          <tbody className={dataLoading || !data.length ? 'd-none' : ''}>
            <CommandHistoryBody data={data} />
          </tbody>
          <style jsx>{`
            .table {
              table-layout: fixed;
            }
          `}</style>
        </table>
      </div>
      {(() => {
        switch (true) {
          case dataLoading:
            return (
              <div className="h-75 w-100 d-flex align-items-center justify-content-center">
                <Loading />
              </div>
            );
          case !remote:
            return (
              <div className="h-75 w-100 d-flex flex-column align-items-center justify-content-center">
                <FontAwesomeIcon
                  icon={faWifi}
                  className="text-brand-primary mb-3"
                  size="5x"
                />
                <h4 className="text-brand-primary">
                  This asset is not remote enabled
                </h4>
              </div>
            );
          case !data.length:
            return (
              <div className="h-75 w-100 d-flex flex-column align-items-center justify-content-center">
                <FontAwesomeIcon
                  icon={faWifi}
                  className="text-brand-primary mb-3"
                  size="5x"
                />
                <h5 className="text-brand-primary">
                  No commands have been fired on this asset!
                </h5>
              </div>
            );
          default:
            return null;
        }
      })()}
    </>
  );
}

CommandHistoryTable.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      commandId: PropTypes.string,
      createdAt: PropTypes.string,
      email: PropTypes.string,
      gatewayId: PropTypes.string,
      jobCommand: PropTypes.string,
      jobMessage: PropTypes.string,
      jobName: PropTypes.string,
      status: PropTypes.oneOf([
        'COMPLETED',
        'FAILED',
        'MESSAGE_SENT',
        'RUNNING',
        'PENDING',
      ]),
      templateId: PropTypes.string,
      updatedAt: PropTypes.string,
    })
  ),
  dataLoading: PropTypes.bool,
  sort: PropTypes.object,
  handleSortClick: PropTypes.func,
  remote: PropTypes.bool,
  status: PropTypes.oneOf([
    '',
    'COMPLETED',
    'FAILED',
    'MESSAGE_SENT',
    'RUNNING',
    'PENDING',
  ]),
  handleStatusSelect: PropTypes.func,
  jobName: PropTypes.string,
  handleSearch: PropTypes.func,
};

CommandHistoryTable.defaultProps = { data: [], dataLoading: true, sort: {} };

export default memo(CommandHistoryTable);
